module.exports = __webpack_public_path__ + "img/OTT.fede89b4.jpg";